<template lang="pug">
page: slot
</template>

<script>
import Vue from "vue";
import Page from "@/components/Page";
import Component from "vue-class-component";

@Component({
	components: { Page }
})
class BaseView extends Vue {}

export default BaseView;
</script>

<style lang="stylus" scoped></style>
